<template>
  <div>
    <el-form
      :inline="inline"
      :class="noBorderBottom ? 'no-border-bottom query-form' : 'query-form'"
      ref="form"
      label-position="right"
    >
      <template>
        <el-form-item v-for="(i, j) in List" :key="j" :label="i.label">
          <!-- 文本输入框 -->
          <template v-if="i.type === 'input'">
            <el-input
              :style="'margin: auto; width:' + i.contentWidth || '160px'"
              :class="i.class || ''"
              v-model.trim="i.value"
              :clearable="i.clearable||true"
              :readonly="!!i.readonly"
              :type="i.InputType || 'text'"
              :placeholder="i.placeholder || '请输入'"
              @input="changeValue($event, i.key)"
            />
          </template>
          <!-- 文本输入框范围 -->
          <template v-if="i.type === 'input_two'">
            <div class="flex">
              <el-input
                :style="'margin: auto; width:' + i.contentWidth || '50px'"
                :class="i.class || ''"
                v-model.trim="i.value"
                :clearable="!!i.clearable"
                :type="i.InputType || 'text'"
                :placeholder="i.placeholder || '请输入'"
                @input="changeValue($event, i.key)"
              />
              <span class="m-l-10 m-r-10">~</span>
              <el-input
                :style="'margin: auto; width:' + i.contentWidth || '50px'"
                :class="i.class || ''"
                v-model.trim="i.value1"
                :clearable="!!i.clearable"
                :type="i.InputType || 'text'"
                :placeholder="i.placeholder || '请输入'"
                @input="changeValue($event, i.key1)"
              />
            </div>
          </template>
          <template v-if="i.type === 'region'">
            <el-cascader
              v-model="i.value"
              :clearable="!!i.clearable"
              :filterable="!!i.filterable"
              :placeholder="i.placeholder || '请选择'"
              @change="handleChange"
              ref="region"
              :props="props"
              :options="region"
            >
            </el-cascader>
          </template>
          <!-- 选择框 -->
          <template v-if="i.type === 'select'">
            <el-select
              :multiple="i.multiple"
              :collapse-tags="i.collapseTags"
              style="width: 198px"
              v-model="i.value"
              :clearable="!!i.clearable || true"
              :filterable="!!i.filterable || true"
              :placeholder="i.placeholder || '请选择'"
              @change="changeValue($event, i.key)"
              :remote="i.remote || false"
              :disabled="i.disabled || false"
              :remote-method="i.remote_method"
            >
              <el-option
                v-for="(item, index) in i.options"
                :key="index"
                :label="(i.resetKey && item[i.resetKey.label]) || item.name"
                :value="(i.resetKey && item[i.resetKey.value]) || item.id"
              />
            </el-select>
          </template>
          <template v-if="i.type === 'select_dis'">
            <el-select
              :multiple="i.multiple"
              :collapse-tags="i.collapseTags"
              style="width: 198px"
              v-model="i.value"
              :clearable="!!i.clearable || true"
              :filterable="!!i.filterable || true"
              :placeholder="i.placeholder || '请选择'"
              @change="changeValue($event, i.key)"
              :remote="i.remote || false"
              :disabled="i.disabled || false"
              :remote-method="i.remote_method"
            >
              <el-option
                v-for="(item, index) in i.options"
                :key="index"
                :label="(i.resetKey && item[i.resetKey.label]) || item.name"
                :value="(i.resetKey && item[i.resetKey.value]) || item.id"
                :disabled="(i.resetKey && !item[i.resetKey.disabled]) || item.disabled"
              />
            </el-select>
          </template>
          <template v-if="i.type === 'select_input'">
            <el-input
              :placeholder="i.placeholder || '请输入'"
              v-model="i.value1"
              class="input-with-select"
            >
              <el-select
                v-model="i.value"
                slot="prepend"
                placeholder="请选择"
                class="select"
              >
                <el-option
                  :label="it.label"
                  :value="it.value"
                  v-for="(it, t) in i.options"
                  :key="t"
                ></el-option>
              </el-select>
            </el-input>
          </template>
          <!-- 级联选择器 -->
          <template v-if="i.type === 'cascader'">
            <el-cascader
              :options="i.options"
              style="width: 150px"
              v-model.trim="i.value"
              :clearable="!!i.clearable"
              :placeholder="i.placeholder || '请选择'"
              :props="i.propsData || { expandTrigger: 'hover' }"
              @change="changeValue($event, i.key)"
            >
            </el-cascader>
          </template>
          <!-- 时间选择器 -->
          <template v-if="i.type === 'date'">
            <el-date-picker
              style="width: 198px"
              v-model="i.value"
              type="date"
              :placeholder="i.placeholder || '请选择'"
              :value-format="i.valueFormat || 'yyyy-MM-dd'"
              :picker-options="i.pickerOptions"
              @change="changeValue($event, i.key)"
            />
          </template>
          <!-- 时间选择器 -->
          <template v-if="i.type === 'datetime'">
            <el-date-picker
              style="width: 198px"
              v-model="i.value"
              type="datetime"
              :placeholder="i.placeholder || '请选择'"
              :value-format="i.valueFormat || 'yyyy-MM-dd HH:mm:ss'"
              :picker-options="i.pickerOptions"
              @change="changeValue($event, i.key)"
            />
          </template>
          <!-- 年份选择器 -->
          <template v-if="i.type === 'year'">
            <el-date-picker
              style="width: 198px"
              v-model="i.value"
              type="year"
              :placeholder="i.placeholder || '请选择'"
              :value-format="i.valueFormat || 'yyyy'"
              :picker-options="i.pickerOptions"
              @change="changeValue($event, i.key)"
            />
          </template>
          <!-- 区间日期选择器 -->
          <template v-if="i.type === 'datePicker'">
            <el-date-picker
              v-model="i.value"
              type="daterange"
              range-separator="-"
              :start-placeholder="i.placeholder || '请选择开始日期'"
              :end-placeholder="i.placeholder || '请选择结束日期'"
              :value-format="i.valueFormat || 'yyyy-MM-dd HH:mm:ss'"
              :default-time="['00:00:00', '23:59:59']"
              @change="changeValue($event, i.key)"
            />
          </template>
          <template v-if="i.type === 'monthrange'">
            <el-date-picker
              v-model="i.value"
              unlink-panels
              type="monthrange"
              range-separator="至"
              start-placeholder="开始月份"
              end-placeholder="结束月份"
              :value-format="i.valueFormat || 'yyyy-MM'"
              @change="changeValue($event, i.key)"
              :picker-options="pickerOptions2"
            >
            </el-date-picker>
          </template>
          <!-- 区间日期时间时分秒选择器 -->
          <template v-if="i.type === 'dateTimePickerOne'">
            <el-date-picker
              :picker-options="i.picker === 'before' ? expireTimeOPtion : ''"
              v-model="i.value"
              type="datetimerange"
              range-separator="-"
              :start-placeholder="i.placeholder || '请选择开始日期'"
              :end-placeholder="i.placeholder || '请选择结束日期'"
              :value-format="i.valueFormat || 'yyyy-MM-dd HH:mm:ss'"
              @change="changeValue($event, i.key)"
            />
          </template>
          <!-- 区间日期时间选择器 -->
          <template v-if="i.type === 'dateTimePicker'">
            <el-date-picker
              v-model="i.value"
              type="daterange"
              range-separator="-"
              :start-placeholder="i.placeholder || '请选择开始日期'"
              :end-placeholder="i.placeholder || '请选择结束日期'"
              :value-format="i.valueFormat || 'yyyy-MM-dd'"
              :format="i.valueFormat || 'yyyy-MM-dd'"
              @change="changeValue($event, i.key)"
            />
          </template>
          <template v-if="i.type === 'dateTimePickerGJ'">
            <el-date-picker
              v-model="i.value"
              type="daterange"
              range-separator="-"
              :start-placeholder="i.placeholder || '请选择开始日期'"
              :end-placeholder="i.placeholder || '请选择结束日期'"
              @change="changeValue($event, i.key)"
            />
          </template>
          <!-- 类型 区间日期选择器 -->
          <template v-if="i.type === 'select_date_picker'">
            <div class="flex">
              <el-select
                :collapse-tags="i.collapseTags"
                style="width: 130px"
                v-model="i.value1"
                :clearable="!!i.clearable"
                :filterable="!!i.filterable"
                :placeholder="i.placeholder || '请选择'"
                @change="changeValue($event, i.key1)"
              >
                <el-option
                  v-for="(item, index) in i.options"
                  :key="index"
                  :label="(i.resetKey && item[i.resetKey.label]) || item.label"
                  :value="(i.resetKey && item[i.resetKey.value]) || item.value"
                />
              </el-select>
              <el-date-picker
                v-model="i.value"
                type="daterange"
                range-separator="-"
                :start-placeholder="i.placeholder || '请选择'"
                :end-placeholder="i.placeholder || '请选择'"
                value-format="yyyy-MM-dd"
                @change="changeValue($event, i.key)"
              />
            </div>
          </template>
          <template v-if="i.type === 'select_time_picker'">
            <div class="flex">
              <el-select
                :collapse-tags="i.collapseTags"
                style="width: 130px"
                v-model="i.value1"
                :clearable="!!i.clearable"
                :filterable="!!i.filterable"
                :placeholder="i.placeholder || '请选择'"
                @change="changeValue($event, i.key1)"
              >
                <el-option
                  v-for="(item, index) in i.options"
                  :key="index"
                  :label="(i.resetKey && item[i.resetKey.label]) || item.label"
                  :value="(i.resetKey && item[i.resetKey.value]) || item.value"
                />
              </el-select>
              <template v-if="i.value1 === 'year'">
                <el-date-picker
                  v-model="year[0]"
                  type="year"
                  placeholder="开始年份"
                  :value-format="i.valueFormat || 'yyyy-MM-dd HH:mm:ss'"
                  @change="changeYear($event, i.key)"
                >
                </el-date-picker>
                ～
                <el-date-picker
                  v-model="year[1]"
                  type="year"
                  :value-format="i.valueFormat || 'yyyy-MM-dd HH:mm:ss'"
                  placeholder="结束年份"
                  @change="changeYear($event, i.key, year)"
                >
                </el-date-picker>
              </template>
              <template v-if="i.value1 === 'month'">
                <el-date-picker
                  v-model="i.value"
                  type="monthrange"
                  range-separator="至"
                  start-placeholder="开始月份"
                  end-placeholder="结束月份"
                  :value-format="i.valueFormat || 'yyyy-MM-dd HH:mm:ss'"
                  @change="changeValue($event, i.key)"
                  :picker-options="pickerOptions"
                >
                </el-date-picker>
              </template>
              <el-date-picker
                v-if="i.value1 === 'day'"
                v-model="i.value"
                type="daterange"
                range-separator="-"
                :start-placeholder="i.placeholder || '请选择'"
                :end-placeholder="i.placeholder || '请选择'"
                :value-format="i.valueFormat || 'yyyy-MM-dd HH:mm:ss'"
                @change="changeValue($event, i.key)"
                :picker-options="pickerOptions"
              />
            </div>
          </template>
          <!-- 复选框 -->
          <template v-if="i.type === 'checkbox'">
            <el-checkbox-group v-model="i.value">
              <el-checkbox
                :label="option.value"
                v-for="option in i.options"
                :key="option.value"
                >{{ option.label }}
              </el-checkbox>
            </el-checkbox-group>
          </template>
          <!-- 单选框 -->
          <template v-if="i.type === 'radiobox'">
            <el-radio-group
              v-model="i.value"
              @change="changeValue($event, i.key)"
            >
              <el-radio
                :label="option.value"
                v-for="option in i.options"
                :key="option.value"
                >{{ option.label }}
              </el-radio>
            </el-radio-group>
          </template>
          <template v-if="i.type === 'twomoney'">
            <div class="df">
              <el-input
                type="number"
                v-model="i.value"
                :clearable="!!i.clearable"
                placeholder="请输入数字"
              ></el-input>
              ～
              <el-input
                type="number"
                v-model="i.value1"
                placeholder="请输入数字"
                :clearable="!!i.clearable"
              ></el-input>
            </div>
          </template>
        </el-form-item>
      </template>
      <el-form-item v-if="needSearchBtn">
        <el-button
            v-if="!needUpload"
            type="primary"
            :style="lightColor?'background-color: #6ca5ff':'background-color: #1890FF'"
            @click="search" icon="el-icon-search"
            v-waves
            :loading="buttonLoading">
          {{ btnName?btnName:'搜索' }}
        </el-button>
        <el-button v-if="needUpload" type="primary" @click="search" icon="el-icon-search" v-waves
          >上传</el-button
        >
        <el-button v-if="needDownloadBtn" type="primary" @click="download" icon="el-icon-download" v-waves
          >下载</el-button
        >
        <!-- <el-button @click="reset">重置</el-button> -->
      </el-form-item>
      <slot></slot>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    inline: {
      type: Boolean,
      default: true,
    },
    needSearchBtn: {
      type: Boolean,
      default: true,
    },
    showLoading: {
      type: Boolean,
      default: false,
    },
    needDownloadBtn: {
      type: Boolean,
      default: false,
    },
    needUpload: {
      type: Boolean,
      default: false,
    },
    List: {
      type: Array,
      default: () => [],
    },
    noBorderBottom: {
      type: Boolean,
      default: false,
    },
    table_col: {
      type: Array,
      default: () => [],
    },
    controller: {
      type: String,
      default: "",
    },
    btnName: {
      type: String,
      default: "",
    },
    is_region: {
      type: Boolean,
      default: false,
    },
    lightColor: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      expireTimeOPtion: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6; // 如果没有后面的-8.64e6就是不可以选择今天的
        },
      },
      show: false,
      buttonLoading: false,
      props: {
        lazy: true,
        lazyLoad: async (node, resolve) => {
          let nodes = await this.handleChange(node);
          // 通过调用resolve将子节点数据返回，通知组件数据加载完成
          resolve(nodes);
        },
        value: "id",
        // 显示的文字字段名
        label: "name",
        // 子层级字段名
        children: "child",
      },
      region: [],
      year: [],
      pickerOptions: {
        disabledDate: (time) => {
          return time.getTime() > Date.now();
        },
      },
      pickerOptions2: {
        shortcuts: [
          {
            text: "上个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              end.setMonth(start.getMonth() - 1);
              start.setMonth(start.getMonth() - 1);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近六个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setMonth(start.getMonth() - 6);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
        disabledDate: (time) => {
          return time.getTime() > Date.now();
        },
      },
    };
  },
  created() {
    if (this.is_region) this.getPCD();
  },
  methods: {
    reset() {
      // 重置
      this.List.forEach((item) => {
        if (item.no_reset) {
          this.$set(item, "value", item.value1);
          return;
        }
        if (item.type === "select_input") {
          this.$set(item, "value1", "");
        } else {
          this.$set(item, "value", item.default || "");
          if (item.value1) this.$set(item, "value1", "");
        }
      });
      this.$emit("search", "reset");
    },
    search() {
      if(this.showLoading) {
        this.buttonLoading = true
      }
      // 查询
      let form = {};
      for (let i of this.List) {
        if (i.value !== null) {
          if(i.value === "") {
            form[i.key] = null;
          } else {
            form[i.key] = i.value;
          }
        }
        if (
          i.type == "select_input" ||
          i.type == "select_date_picker" ||
          i.type == "select_time_picker" ||
          i.type == "input_two" ||
          i.type == "twomoney"
        ) {
          if (i.value1 !== "") {
            form[i.key1] = i.value1;
          }
        }
        if (i.type == "select_time_picker" && i.value1 === "year") {
          form[i.key] = this.year;
        }
      }
      this.$emit("search", form)
    },
    download() {
      // 查询
      let form = {};
      for (let i of this.List) {
        if (i.value !== null) {
          form[i.key] = i.value;
        }
        if (
          i.type == "select_input" ||
          i.type == "select_date_picker" ||
          i.type == "select_time_picker" ||
          i.type == "input_two" ||
          i.type == "twomoney"
        ) {
          if (i.value1 !== "") {
            form[i.key1] = i.value1;
          }
        }
        if (i.type == "select_time_picker" && i.value1 === "year") {
          form[i.key] = this.year;
        }
      }
      this.$emit("download", form);
    },
    changeValue(value, key) {
      this.$emit("changeValue", {
        key,
        value,
      });
    },
    changeYear() {
      this.$emit("changeValue", {
        key: "time",
        value: this.year,
      });
    },
    async getPCD() {
      try {
        const res = await this.$api.common.get("dict/location", {
          pId: "",
          type: "PROVINCE",
        });
        this.region = res;
      } catch {}
    },
    finishLoading() {
      this.buttonLoading = false
    },
    async handleChange(res) {
      try {
        // let res = this.$refs.region.getCheckedNodes()[0];
        const res1 = await this.$api.common.get("dict/location", {
          pId: res.data.id,
          type: res.data.type == "PROVINCE" ? "CITY" : "AREA",
        });
        if (res.data.type == "CITY") {
          res1.forEach((t) => {
            t.leaf = true;
          });
        }
        res.child = res1;
        return res1;
      } catch {}
    },
  },
};
</script>

<style scoped lang="scss">
.query-form {
  &.no-border-bottom {
    border: none;
  }

  ::v-deep .el-form-item {
    margin-bottom: 8px;

    .el-input__inner {
      padding-left: 8px;
      padding-right: 8px;
    }

    .el-date-editor {
      .el-input__inner {
        padding-left: 30px !important;
      }
    }
    .el-date-editor.el-input,
    .el-input,
    .el-select {
      width: 150px !important;
    }
    .el-date-editor.el-input__inner {
      width: 330px !important;
    }
    .input-with-select {
      input {
        width: 150px !important;
      }
      .select {
        .el-input,
        &.el-select {
          width: 120px !important;
        }
        input {
          width: 120px !important;
        }
      }
    }
  }
}

// ::v-deep .el-select__tags {
//   flex-wrap: nowrap;
//   margin-left: 1px;
//   overflow: hidden;
//   white-space: nowrap;
//   text-overflow: ellipsis;
// }
</style>
